var mySwiperOffers = new Swiper('.swiper-offers', {
    direction: 'horizontal',
    loop: true,
    speed: 700,
    spaceBetween: 80,
    grabCursor: false,
    // slidesPerView: 'auto',
    // centeredSlides: true,
    width: 400,
    breakpoints: {
        320: {
            width: 300,
            touchRatio: 1,
        },
        480: {
            width: 400,
            touchRatio: 0,
        },

    },
    autoplay: {
        delay: 3000
    },
    navigation: {
        nextEl: '.button-next-offers',
        prevEl: '.button-prev-offers',
    },
    scrollbar: {
        el: '.offers-scrollbar',
    },
});

if (mySwiperOffers.scrollbar != undefined) {
    mySwiperOffers.scrollbar.updateSize();
}